import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear } from '@fortawesome/sharp-solid-svg-icons/faGear';

import styles from '../app-header.module.less';

export const SettingsIcon = () => <FontAwesomeIcon className={styles['menu-item-icon']} icon={faGear} />;
